import React from 'react'

import { Box, useBreakpoint } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import AmazonCards from 'modules/referral_program/components/AmazonCards/AmazonCards'
import HeaderLink from 'modules/referral_program/components/ReferralProgramRevamp/HeaderLink'
import { referralUrlForLocale } from 'modules/referral_program/components/helpers'
import BannerImage from 'modules/referral_program/lib/assets/iphone_air_landing.png'

interface ReferralProgramHeaderProps {
  isoCountryCode: string
}

const ReferralProgramHeader: React.FC<ReferralProgramHeaderProps> = ({ isoCountryCode }) => {
  const { isMobile, breakpoint } = useBreakpoint()
  const {
    access: { userId, locale },
    company,
    email,
  } = useCurrentSession()
  const base64Code = btoa(JSON.stringify({ companyId: company.id, userId, userEmail: email }))
  const shareUrl = `${referralUrlForLocale(locale.toLowerCase())}/${base64Code}`
  const isBrazil = isoCountryCode === 'br'
  if (false) {
    ;[
      i18n.t('company_settings.general.factorial_referral_program.revamp.button.generate_link'),
      i18n.t('company_settings.general.factorial_referral_program.revamp.button.reset'),
      i18n.t('company_settings.general.factorial_referral_program.revamp.reward_modal.title'),
      i18n.t('company_settings.general.factorial_referral_program.revamp.reward_modal.description'),
      i18n.t(
        'company_settings.general.factorial_referral_program.revamp.reward_modal.items.price_1.title'
      ),
      i18n.t(
        'company_settings.general.factorial_referral_program.revamp.reward_modal.items.price_1.description'
      ),
      i18n.t(
        'company_settings.general.factorial_referral_program.revamp.reward_modal.items.price_2.title'
      ),
      i18n.t(
        'company_settings.general.factorial_referral_program.revamp.reward_modal.items.price_2.description'
      ),
      i18n.t(
        'company_settings.general.factorial_referral_program.revamp.reward_modal.items.price_3.title'
      ),
      i18n.t(
        'company_settings.general.factorial_referral_program.revamp.reward_modal.items.price_3.description'
      ),
      i18n.t(
        'company_settings.general.factorial_referral_program.revamp.reward_modal.button.generate_link'
      ),
      i18n.t(
        'company_settings.general.factorial_referral_program.revamp.reward_modal.button.generating_link'
      ),
      i18n.t('company_settings.general.factorial_referral_program.revamp.subtitle'),
      i18n.t('company_settings.general.factorial_referral_program.revamp.title'),
      i18n.t('company_settings.general.factorial_referral_program.iphone_air.title_banner'),
      i18n.t('company_settings.general.factorial_referral_program.iphone_air.subtitle_banner'),
      i18n.t('company_settings.general.factorial_referral_program.iphone_air.title_landing'),
      i18n.t('company_settings.general.factorial_referral_program.iphone_air.subtitle_landing'),
    ]
  }

  return (
    <>
      <Box
        flexDirection={isMobile ? 'column' : 'row'}
        gap="s32"
        width="full"
        minHeight="s300"
        paddingTop={isMobile ? 's0' : 's32'}
        justifyContent="center"
      >
        <Box
          flexDirection={isMobile ? 'column' : 'row'}
          style={{
            maxWidth: '1200px',
          }}
          width="full"
          gap="s32"
        >
          <HeaderLink shareUrl={shareUrl} isoCountryCode={isoCountryCode} />

          {isBrazil ? (
            <AmazonCards enableAnimation />
          ) : (
            <img
              src={BannerImage}
              alt="Header Cards"
              style={{ maxWidth: isMobile ? '100%' : breakpoint === 'l' ? '500px' : '720px' }}
            />
          )}
        </Box>
      </Box>
    </>
  )
}

export default ReferralProgramHeader
